import { createContext } from "react"
import { DefaultSupportAssuranceInterface, SupportAssuranceInterface } from "../../types"

export interface ShowSupportAssurancesInterface {
  showSuccessMsg: boolean,  setShowSuccessMsg: (showSuccessMsg: boolean) => void,
  showAddModal: boolean,  setShowAddModal: (showAddModal: boolean) => void,
  showEditModal: boolean, setShowEditModal: (showEditModal: boolean) => void,
  showDeleteModal: boolean, setShowDeleteModal: (showDeleteModal: boolean) => void,
  selectedSupportAss: SupportAssuranceInterface, setSelectedSupportAss: (selectedSupportAss: SupportAssuranceInterface) => void,
}

export const DefaultShowSupportAssurancesInterface:ShowSupportAssurancesInterface = {
  showSuccessMsg: false,  setShowSuccessMsg: () => {},
  showAddModal: false,  setShowAddModal: () => {},
  showEditModal: false, setShowEditModal: () => {},
  showDeleteModal: false,   setShowDeleteModal: () => {},
  selectedSupportAss: DefaultSupportAssuranceInterface, setSelectedSupportAss: () => {},
}

export const ShowSupportAssurancesContext = createContext<ShowSupportAssurancesInterface>(DefaultShowSupportAssurancesInterface)

export interface DataSupportAssurance {
  amount: string, setAmount: (amount: string) => void,
  createdAt: string, setCreatedAt: (createdAt: string) => void,
}

export const DefaultDataSupportAssurance: DataSupportAssurance = {
  amount: "", setAmount: () => {},
  createdAt: "", setCreatedAt: () => {},
}

export const DataSupportAssuranceContext = createContext<DataSupportAssurance>(DefaultDataSupportAssurance)
